<template>

    <div>
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-1 mb-2">
                <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                    <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
            </div>
            <div class="mb-2 col-md-3 text-right">
            </div>
        </div>
        <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr class="pointer" @click="$router('/administration/souscriptions/me/show/'+subscription.uuid)" v-for="subscription in subscriptions" :key="subscription.id">
                    <td>{{subscription.id}}</td>
                    <td>{{subscription.name || '—'}}</td>
                    <td>{{subscription.product || '—'}}</td>
                    <td>{{$format(subscription.amount) }}</td>
                    <td>{{subscription.inter_name || '—'}}</td>
                    <td>{{subscription.created_at || '—'}}</td>
                    <td>
                        <span v-if="subscription.status === 'add'" class="badge badge-pill badge-info">Paiement à la livraison</span>
                        <span v-if="subscription.status === 'negotiated' && subscription.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                        <span v-if="subscription.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                        <span v-if="subscription.status === 'negotiated' && subscription.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                        <span v-if="subscription.status === 'wait_negotiate' || subscription.status === 'in_negotiated'" class="badge badge-pill badge-info">En négociation</span>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-paginate :links="links" :navigationFunction="navigation"/>
    </div>
</template>

<script>

    import vTable from '../../../../components/vTable/vTable.vue';
    import vPaginate from '../../../../components/vTable/vPaginate1.vue'
    import axios from "axios";
    import {api, _buildQuery } from "../../../../helpers/shared";
    /**********************************************/

    /**********************************************/
    const default_customize = {
        labelShowing: 'Show',
        labelEntries: 'entries',
        entries: [10, 15, 20, 25, 30],
        labelSearch: 'Search',
        labelLoading: 'Loading...',
        labelDetails: 'Showing 0 to 0 of 0 entries'
    };

    export default {
        name: "allSubscription",
        components: {vTable,vPaginate},
        props: ['content'],
        data(){
            let sortOrders = {};
            let columns = [
                {width: '33%', label: 'id', name: 'reference' },
                {width: '33%', label: 'client', name: 'name'},
                {width: '33%', label: 'produit', name: 'product'},
                {width: '33%', label: 'montant(Fcfa)', name: 'amount'},
                {width: '33%', label: 'point de vente', name: 'inter_name'},
                {width: '33%', label: 'date', name: 'created_at'},
                {width: '33%', label: 'statut', name: 'status'}
            ];
            return {
                loading: false,
                exporting: false,
                links: [],
                subscriptions: [],
                query:{
                    page: 1,
                    per: 10,
                    namespace: 'all',
                    product: ''
                },
                /**************************************************/
                columns: columns,
                sortKey: '',
                sortOrders: sortOrders,
                perPage: ['5','10', '20', '30'],
                tableData: {
                    page: 0,
                    length: 5,
                    search: '',
                    column: 0,
                    dir: 'desc',
                    state: 'all',
                    product:'',
                    status:'',
                },
            }
        },
        mounted() {
            this.getSubscription();
        },
        methods:{
            makeFilter(query){
                this.query = { ...query };
                this.loading = true;
                axios.get(api('administration/subscriptions/me'+_buildQuery(this.query)))
                    .then((response) => {

                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },

            makeSelected(val){
                this.loading = true;
                this.query.per = val;
                axios.get(api('subscriptions/me'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },
            /*******************************/
            getSubscription(url = 'administration/subscriptions/me') {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
                color: "#4B4B4B",
                backgroundColor: "#4B4B4B",
                height: 35,
                width: 35,
                loader: "bars",
                opacity: 0.3,
            });
            this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    loader.hide();
                    let content = response.data;
                    this.subscriptions = content.data;
                    console.log(this.subscriptions)
                    this.configPagination(content);
                })
                .catch(errors => {
                    loader.hide();
                    console.log(errors);
                });
            },
            changePerPage(url = 'administration/subscriptions/me'){
                this.tableData.page = 1;
                axios.get(api(url), {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.subscriptions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    loader.hide();
                    console.log(errors);
                });
            },
            configPagination(data) {
                this.links = data.links;
            },
            getNext(url){
                this.tableData.page ++;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.subscriptions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            getPrev(url){
                this.tableData.page --;
                axios.get(url, {params: this.tableData})
                .then(response => {
                    let content = response.data;
                    this.subscriptions = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
            },
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                this.tableData.column = this.getIndex(this.columns, 'name', key);
                this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
                this.getProspects();
            },
            navigation(page) {
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                    color: "#4B4B4B",
                    backgroundColor: "#4B4B4B",
                    height: 35,
                    width: 35,
                    loader: "bars",
                    opacity: 0.3,
                });
                this.tableData.page = page;
                axios.get(api('administration/subscriptions/me'), {params: this.tableData})
                    .then(response => {
                        loader.hide();
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        loader.hide();
                        console.log(errors);
                    });
            },
        }
    }
</script>

<style scoped>
    .pointer{
        cursor: pointer;
    }
</style>
